<template>
  <span>
    <div class="control-group field">
      <input name="guest_drug[infusion]" type="hidden" v-model="isInfusion" />
      <div class="row-fluid">
        <div class="pull-left">
          <a :class="['btn', { active: isInfusion }]" @click="toggleInfusion" id="btn_terapia_composta" :disabled="alreadySomministrered">
            <fa-icon :icon-name="'fa-vials'" :no-theme="true" />
            {{ i18nJS.infusion_therapy }}
          </a>
        </div>
        <div v-if="isInfusion" class="pull-right">
          <a href="javascript:void(0)" @click="addInfusionTherapy" :class="`${alreadySomministrered ? 'disabled-adv' : ''}`">
            <fa-icon :icon-name="'fa-plus'" class="radius" />
          </a>
        </div>
      </div>
    </div>
    <div v-if="isInfusion" class="control-group field">
      <div class="row-fluid">
        <div :class="['span3', offsetHeader]">
          {{ i18nJS.qta }}
        </div>
      </div>
      <span v-for="(therapy, index) in infusions" :key="therapy.tempId" v-show="therapy.status === 1">
        <div class="row-fluid" :class="`${alreadySomministrered ? 'disabled-row' : ''}`">
          <div :class="[spanDimension, 'button-table']" v-if="infusions.length > 2 || warehouseActive">
            <a v-if="infusions.length > 2" href="javascript:void(0)" @click="() => deleteTherapy(therapy)">
              <fa-icon :icon-name="'fa-trash'" class="radius" />
            </a>
            <a v-if="warehouseActive" href="javascript:void(0)" @click="() => openModal(index)" class="pull-rigth warehouseButton">
              <fa-icon :icon-name="'fa-warehouse-alt'" class="radius" style="padding: 11px 9px" />
            </a>
          </div>
          <div class="span4 mychzn-obbligatorio" style="padding-top: 4px">
            <v-select2
              :data-ajax--url="drugsUrl"
              class="myinput-xxlarge"
              style="width: 100%"
              :id="`infusion_therapies_${index}_drug_id`"
              :name="`guest_drug[infusion_therapies_attributes][${index}][drug_id]`"
              v-model="therapy['drug_id']"
              :options-list="[[therapy['description'], therapy['drug_id']]]"
              :element_description.sync="therapy['description']"
              data-allow--clear="true"
              @input="infusionDrugChange($event)"
            />
          </div>
          <div class="span5 obbligatorio" style="padding-top: 4px">
            <!--input della descrizione personalizzata-->
            <input
              type="text"
              class=""
              style="width: 100%"
              v-model="therapy['description_pers']"
              :id="`infusion_therapies_${index}_description_pers`"
              :name="`guest_drug[infusion_therapies_attributes][${index}][description_pers]`"
            />
          </div>
          <div class="span3 obbligatorio">
            <input
              type="text"
              class="input-mini"
              v-model="therapy['qta_s']"
              :id="`infusion_therapies_${index}_qta_s`"
              :name="`guest_drug[infusion_therapies_attributes][${index}][qta_s]`"
            />
            <a href="javascript:void(0)" @click="() => openPopup(index)">
              <fa-icon :icon-name="'fa-magnifying-glass'" style="padding: 11px 9px; color: gray" />
            </a>
          </div>
        </div>
        <!--        <div v-if="therapy.description" class="row-fluid">-->
        <!--          <div :class="['span10', 'infusion-description', offsetInfusionDescription]">{{ therapy.description }}</div>-->
        <!--        </div>-->
        <input type="hidden" v-if="therapy.id" :name="`guest_drug[infusion_therapies_attributes][${index}][id]`" :value="therapy.id" />
        <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][status]`" :value="therapy.status" />
        <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][guest_drug_id]`" :value="therapy.guest_drug_id" />
        <input
          type="hidden"
          :name="`guest_drug[infusion_therapies_attributes][${index}][guest_business_unit_id]`"
          :value="guestBusinessUnitId"
        />
        <span v-if="warehouseActive">
          <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][somm_form]`" :value="therapy.somm_form" />
          <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][qta_tot]`" :value="therapy.qta_tot" />
          <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][um_somm]`" :value="therapy.um_somm" />
          <input type="hidden" :name="`guest_drug[infusion_therapies_attributes][${index}][val_conv]`" :value="therapy.val_conv" />
        </span>
        <infusion-modal
          v-if="warehouseActive"
          :infusion="therapy"
          :index="index"
          :um-somm-options="umSommOptions"
          :somm-form-options="sommFormOptions"
          :principio-attivo="principioAttivo"
        />
      </span>
      <hr />
      <infusion-search-drugs
        :drugs-description-url="drugsDescriptionUrl"
        :drugs-name-url="drugsNameUrl"
        ref="searchDrugsModal"
        @setDrug="(params) => this.setDrug(params)"
        v-if="popupOpened"
        :popup-opened="popupOpened"
        :popup-key="popupKey"
      />
    </div>
  </span>
</template>
<script>
import faIcon from '../faIcon';
import vSelect2 from '../vSelect2';
import infusionModal from './infusionModal';
import InfusionSearchDrugs from './infusionSearchDrugsModal.vue';
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'infusionForm',
  props: [
    'infusion',
    'infusionTherapies',
    'drugsUrl',
    'guestBusinessUnitId',
    'warehouseActive',
    'umSommOptions',
    'copyDrugUrl',
    'sommFormOptions',
    'principioAttivo',
    'alreadySomministrered',
    'drugSync',
    'drugsDescriptionUrl',
    'drugsNameUrl',
  ],
  components: {
    faIcon,
    vSelect2,
    infusionModal,
    InfusionSearchDrugs,
  },
  data() {
    return {
      isInfusion: this.infusion,
      infusions: this.setupInfusions(),
      popupOpened: false,
      currentSelection: 0,
      popupKey: 'searchDrugsPopup-1',
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    offsetInfusionDescription() {
      let offset = 0;
      if (this.infusions.length > 2) {
        offset += 1;
      }
      if (this.warehouseActive) {
        offset += 1;
      }
      if (offset <= 0) return;
      return 'offset' + offset;
    },
    offsetHeader() {
      let offset = 9;
      if (this.infusions.length > 2) {
        offset += 1;
      }
      if (this.warehouseActive) {
        offset += 1;
      }
      return 'offset' + offset;
    },
    spanDimension() {
      let span = 0;
      if (this.infusions.length > 2) {
        span += 1;
      }
      if (this.warehouseActive) {
        span += 1;
      }
      return 'span' + span;
    },
  },
  watch: {
    isInfusion: {
      immediate: true,
      handler(val) {
        eventBus.$emit('isInfusionChange', val);
        if (val) {
          $('#select-drug-id, #warehouse-wall').hide();
          $('#drug_id_select, .warehouse-input').prop('disabled', true);
          if (this.infusions.length === 0)
            this.infusions = [
              { tempId: this.uuid(), status: 1 },
              { tempId: this.uuid(), status: 1 },
            ];
        } else {
          $('#select-drug-id, #warehouse-wall').show();
          $('#drug_id_select, .warehouse-input').prop('disabled', false);
        }
      },
    },
  },
  mounted() {
    $('.warehouseButton').tooltip({ title: this.i18nJS.conversione_magazzino });
  },
  methods: {
    setupInfusions() {
      return this.infusionTherapies.map((infusion) => {
        return {
          ...infusion,
          description_pers: infusion.description_pers || infusion.description,
          tempId: this.uuid(),
        };
      });
    },
    uuid() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
    addInfusionTherapy() {
      this.infusions.unshift({ tempId: this.uuid(), status: 1 });
      $('.warehouseButton').tooltip({ title: this.i18nJS.conversione_magazzino });
    },
    toggleInfusion() {
      if (this.alreadySomministrered) {
        return;
      }
      this.isInfusion = !this.isInfusion;
    },
    deleteTherapy(therapy) {
      if (therapy.id) {
        therapy.status = 0;
      } else {
        this.infusions = this.infusions.filter((i) => i !== therapy);
      }
    },
    openModal(index) {
      eventBus.$emit('openModalWharehouseTherapy', index);
    },
    openPopup(index) {
      this.currentSelection = index;
      this.popupKey += 1;
      this.popupOpened = true;
    },
    closePopup() {
      this.popupKey += 1;
      this.popupOpened = false;
    },
    infusionDrugChange(id) {
      eventBus.$emit(
        'new_drug_selected_on_guest_drugs',
        this.infusions.map((t) => t.drug_id),
      );
      this.infusions.forEach((therapy, index) => {
        if (therapy.drug_id === id) {
          this.$set(this.infusions[index], 'description_pers', therapy.description);
        }
      });
    },
    async setDrug(newDrug) {
      try {
        Loader.show();
        const response = await apiConnector().post(this.copyDrugUrl, { drug_id: newDrug, custom_dates: true });
        const drug = response.data;

        this.$nextTick(() => {
          let selectedOption = new Option(`${drug.description}`, drug.id, true, true);
          $(`#infusion_therapies_${this.currentSelection}_drug_id`).append(selectedOption).trigger('change');
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.closePopup();
        Loader.hide();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.infusion-description {
  font-style: italic;
  font-size: 85%;
}
.radius {
  border: solid 1px;
  border-radius: 100%;
  padding: 11px 12px;
}

.disabled-adv {
  pointer-events: none;
  opacity: 0.5;
}
</style>

<style lang="scss">
.disabled-row {
  div {
    pointer-events: none;
  }
  input,
  .select2-selection {
    background-color: #eee;
  }

  a {
    opacity: 0.5;
  }
}
</style>
